import { ButtonV2, styled } from '@withjoy/joykit';

export const StyledSuccessGuestButton = styled(ButtonV2)<{ $intent?: 'primary' | 'secondary'; color?: 'string' }>`
  max-width: 394px;
  ${({ $intent, theme }) =>
    $intent !== 'secondary'
      ? `
        background-color: ${theme.colors.green7};
        color: white;
        &:hover { background-color: ${theme.colors.green6}; }
        &:active { background-color: ${theme.colors.green8}; }
      `
      : `
        background-color: transparent;
        color: ${theme.colors.green7};
        border: 1px solid ${theme.colors.green7};
        &:hover { color: ${theme.colors.green6}; border-color: ${theme.colors.green6}; }
        &:active { color: ${theme.colors.green8}; border-color: ${theme.colors.green8}; }
      `}
  ${props => (props.$intent !== 'secondary' && props.color ? `border-color: ${props.color};` : '')}
`;
